import React, { useEffect, useState } from 'react';
import Sidebar from '../components/Sidebar';
import Dashboardview from '../components/Dashboardview';
import { useTable } from 'react-table';
import { FaTimes, FaClock } from 'react-icons/fa'; // Import the icons
import './your-styles.css'; // Import your CSS file
import { addQuestionOfTheDay, deleteQuestionOfTheDay, fetchQuestionOfTheDay, queueQuestionOfTheDay } from '../operators/manageSiteContent';



export default function DailyQuestions() {
  const [dailyQuestions, setDailyQuestions] = useState([]);
  const [message, setMessage] = useState('');

  useEffect(() => {
    document.title = 'Daily Questions - PrayitForward';

    const fetchDailyQuestions = async () => {
      setDailyQuestions(await fetchQuestionOfTheDay());
    };

    fetchDailyQuestions();
  }, []);

  const data = React.useMemo(() => dailyQuestions, [dailyQuestions]);
  const columns = React.useMemo(
    () => [
      {
        Header: 'ID',
        accessor: 'ID',
      },
      {
        Header: 'Message',
        accessor: 'message',
      },
      {
        Header: 'Date Created',
        accessor: 'dateCreated',
        Cell: ({ value }) => {
          const date = new Date(value);
          if (date.toLocaleString() === 'Invalid Date') {
            return 'Never';
          } else {
            return date.toLocaleString(); // Convert to a readable date string
          }
        },
      },
      {
        Header: 'Last Used',
        accessor: 'lastUsed',
        Cell: ({ value }) => {
          const date = new Date(value);
          if (date.toLocaleString() === 'Invalid Date') {
            return 'Never';
          } else {
            return date.toLocaleString(); // Convert to a readable date string
          }
        },
      },

      {
        Header: 'Yes Votes',
        accessor: 'yesV',
      },
      {
        Header: 'No Votes',
        accessor: 'noV',
      },
      
      {
        Header: 'Active',
        accessor: 'active',
        Cell: ({ value }) => {
          if (!value) {
            return 'False';
          } else {
            return 'True';
          }
        },
      },
      {
        Header: 'Queued',
        accessor: 'force',
        Cell: ({ value }) => {
          if (!value) {
            return 'False';
          } else {
            return 'True';
          }
        },
      },
      {
        Header: 'Delete',
        accessor: 'delete',
        Cell: ({ row }) => {
          return (
            <td
              style={{
                padding: '8px',
                borderBottom: '1px solid #ddd',
                cursor: 'pointer',
              }}
              onClick={ async() => {
                deleteQuestionOfTheDay(row.original.ID);
                const updatedQuestions = await fetchQuestionOfTheDay();
                setDailyQuestions(updatedQuestions);
              }}
            >
              <FaTimes />
            </td>
          );
        },
      },
      {
        Header: 'Queue',
        accessor: 'queue',
        Cell: ({ row }) => {
          return (
            <td
              style={{
                padding: '8px',
                borderBottom: '1px solid #ddd',
                cursor: 'pointer',
              }}
              onClick={ async () => {
                queueQuestionOfTheDay(row.original.ID);
                const updatedQuestions = await fetchQuestionOfTheDay();
                setDailyQuestions(updatedQuestions);
              }}
            >
              <FaClock />
            </td>
          );
        },
      },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({ columns, data });

  const handleButtonSubmit = async () => {
    console.log('button pressed', message)
    await addQuestionOfTheDay(message);
    // After adding a new question, update the list of daily questions
    const updatedQuestions = await fetchQuestionOfTheDay();
    setDailyQuestions(updatedQuestions);
    setMessage(''); // Clear the input field
  };

  return (
    <>
      <div className="">
        <div className="flex overflow-scroll">
          <div className="basis-[12%] h-[100vh]">
            <Sidebar />
          </div>
          <div className="basis-[88%] border overflow-scroll h-[100vh]">
            <Dashboardview />

            <div className="flex items-stretchrounded-md overflow-hidden border border-[#4E73DF]">
              <input
                type="text"
                placeholder="Enter your message..."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />
              <button className="custom-button" onClick={handleButtonSubmit}>
                Add Question
              </button>
            </div>

            <table
              {...getTableProps()}
              style={{
                width: '100%',
                border: '1px solid #ddd',
                borderCollapse: 'collapse',
              }}
            >
              <thead>
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                      <th
                        {...column.getHeaderProps()}
                        style={{
                          padding: '8px',
                          textAlign: 'left',
                          backgroundColor: '#f2f2f2',
                          borderBottom: '1px solid #ddd',
                        }}
                      >
                        {column.render('Header')}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {rows.map((row) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()}>
                      {row.cells.map((cell) => {
                        return (
                          <td
                            {...cell.getCellProps()}
                            style={{
                              padding: '8px',
                              borderBottom: '1px solid #ddd',
                            }}
                          >
                            {cell.render('Cell')}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}
